import React from 'react';
import DeliverableChip from '~/features/deliverables/components/DeliverableChip';
import { SUCCESS, FAILED } from '~/features/updateEvents/constants/outcomes';

interface VersionTransitionProps {
    previousVersion: string;
    targetVersion: string;
    outcome: string;
    deliverableId: string;
    deliverableType: string;
}

const VersionTransition = ({ previousVersion, targetVersion, outcome, deliverableId, deliverableType }: VersionTransitionProps) => {
    const isSuccess = outcome === SUCCESS;
    const isFailed = outcome === FAILED;

    return (
        <div className="display-flex align-items-center">
            <DeliverableChip
                isShortVersion={false}
                deliverableId={deliverableId}
                deliverableType={deliverableType}
                deliverableVersion={previousVersion}
                className={isSuccess ? "text-decoration-line-through" : ""}
            />
            <span className="margin-left-5 margin-right-5">→</span>
            <DeliverableChip
                isShortVersion={false}
                deliverableId={deliverableId}
                deliverableType={deliverableType}
                deliverableVersion={targetVersion}
                className={isFailed ? "text-decoration-line-through" : ""}
            />
        </div>
    );
};

export default VersionTransition;
